import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { CREATE_PLC_SAFETY_EVENT } from './actionTypes';
import { createPlcSafetyEventSuccessful, createPlcSafetyEventFailed } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* createEvent({ payload: { event } }) {
  try {
    const response = yield call(plcSafetyAPI.createEvent, event.token, event);
    if (response.message) {
      yield put(createPlcSafetyEventSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(createPlcSafetyEventFailed(error));
  }
}

export function* watchCreatePlcSafetyEvent() {
  yield takeEvery(CREATE_PLC_SAFETY_EVENT, createEvent);
}

function* createPlcSafetyEventSaga() {
  yield all([fork(watchCreatePlcSafetyEvent)]);
}

export default createPlcSafetyEventSaga;
